import { Icon } from '@acpaas-ui/react-components';

const GenericError = () => {
  return (
    <div>
      <h3 className="u-text-danger u-text-center">
        <Icon name="ai-alert-triangle" />
      </h3>
      <p className="u-text-danger u-text-center u-margin-top-xs">
        Er is iets mis gegaan, probeer het alstublieft nogmaals
      </p>
    </div>
  );
};

export default GenericError;
